import React, { useState } from "react";
import { reactDevFaqs } from "../../components/faqData.js";

import Contact from "../../components/Contact.js";
import GetInTouch from "../../components/GetInTouch.js";
import AyanshtechAdvantage from "../../components/AyanshtechAdvantage.js";
import { Helmet } from "react-helmet-async";

const ReactDeveloper = () => {
  const [activeIndex, setActiveIndex] = useState(null);

  const toggleFAQ = (index) => {
    setActiveIndex(index === activeIndex ? null : index);
  };
  const scrollToContact = () => {
    const contactSection = document.getElementById("contact-section");
    contactSection.scrollIntoView({ behavior: "smooth" });
  };

  return (<>
    <Helmet>
      <meta name="description" content="Hire expert React developers in India to build dynamic, high-performing web applications. Get scalable, secure, and cost-effective React development solutions."/>
<meta name="copyright" content="codeglim"/>
<meta property="og:title" content="Hire Expert React Developers in India | Ayanshtech Solutions"/>
<meta property="og:site_name" content="Ayanshtech Solutions"/>
<meta property="og:url" content="https://ayanshtechnology.com/hire-react-developers"/>
<meta property="og:description" content="Hire expert React developers in India to build dynamic, high-performing web applications. Get scalable, secure, and cost-effective React development solutions."/>
<meta property="og:type" content="website"/>
<meta property="og:image" content="https://ayanshtechnology.com/assets/logo.png"/>

<meta name="twitter:card" content="summary"/>
<meta name="twitter:site" content="@Ayanshtech Solutions"/>
<meta name="twitter:title" content="Hire Expert React Developers in India | Ayanshtech Solutions"/>
<meta name="twitter:description" content="Hire expert React developers in India to build dynamic, high-performing web applications. Get scalable, secure, and cost-effective React development solutions."/>
<meta name="twitter:image" content="https://ayanshtechnology.com/assets/logo.png"/>

<link rel="canonical" href="https://ayanshtechnology.com/hire-react-developers"/>
<title>Hire Expert React Developers in India | Ayanshtech Solutions</title>
  </Helmet>
    <div className="min-h-screen flex flex-col items-center justify-center p-6">
      <div className=" p-4 w-full">
        <div className="flex flex-col lg:flex-row items-center lg:space-x-16">
          <div className="lg:w-3/4 lg:text-left ">
            <h1 className="sm:text-3xl md:text-4xl lg:text-5xl font-bold text-gray-800 mb-4">
              Hire Expert React Developers in India
            </h1>
            <p className="sm:text-base md:text-lg lg:text-lg leading-relaxed mb-3">
              React is a leading JavaScript library known for building
              interactive and user-friendly front-end interfaces. Whether you're
              looking to create dynamic single-page applications, improve the
              user experience, or develop a scalable front-end architecture, our
              expert React developers are ready to bring your ideas to life with
              precision and creativity.
              <br />
              <br />
              Take your business to new heights with high-performance front-end
              solutions. Hire our skilled React developers at Ayanshtech to make
              your project a success.
            </p>
            <p className="  text-gray-600 sm:text-lg md:text-xl lg:text-xl">
              Starting from just <span className="font-bold">US $12/hour</span>
            </p>
            <button
              onClick={scrollToContact}
              className="bg-green-600 text-white hover:bg-yellow-500 hover:text-green-700 hover:border hover:border-yellow-500 font-semibold p-3 rounded-full mt-6"
            >
              Hire a React Developer
            </button>
          </div>

          <div className="flex justify-center  lg:mb-0 mt-5">
            <img
              src="\assets\images\headerSection\hireReactDev\img1.png"
              alt="React Solutions for Businesses"
              className="w-full h-auto sm:w-3/4 md:w-2/3 lg:w-full object-contain"
            />
          </div>
        </div>
      </div>

      <div className="text-center mb-5 mt-10">
        <h2 className="sm:text-3xl md:text-4xl lg:text-5xl font-bold text-gray-800">
          Capabilities of Our ReactJS Developers
        </h2>
        <p className="sm:text-base md:text-lg lg:text-xl text-gray-600 font-semibold mt-4 max-w-6xl mx-auto">
          At Ayanshtech, our ReactJS developers deliver tailored solutions to
          clients worldwide. We ensure the rapid development of web applications
          that align seamlessly with your business goals and objectives.
        </p>
      </div>

      <div className=" p-4">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          <div className="flex items-center space-x-4">
            <img
              src="\assets\icons\techIcons\icon1.png"
              alt="icon"
              className="w-10 h-10"
            />
            <p className="text-lg">
              Enhanced User Interface & Experience for better performance
            </p>
          </div>

          <div className="flex items-center space-x-4">
            <img
              src="\assets\icons\techIcons\icon2.png"
              alt="icon"
              className="w-10 h-10"
            />
            <p className="text-lg">Affordable and scalable solutions</p>
          </div>

          <div className="flex items-center space-x-4">
            <img
              src="\assets\icons\techIcons\icon3.png"
              alt="icon"
              className="w-10 h-10"
            />
            <p className="text-lg">
              Real-time interactivity for a dynamic user experience
            </p>
          </div>

          <div className="flex items-center space-x-4">
            <img
              src="\assets\icons\techIcons\icon4.png"
              alt="icon"
              className="w-10 h-10"
            />
            <p className="text-lg">
              Custom-built web applications tailored to your needs
            </p>
          </div>

          <div className="flex items-center space-x-4">
            <img
              src="\assets\icons\techIcons\icon5.png"
              alt="icon"
              className="w-10 h-10"
            />
            <p className="text-lg">Simplified handling and easy maintenance</p>
          </div>
        </div>
      </div>

      <div className="text-center mb-5 mt-10">
        <h2 className="sm:text-3xl md:text-4xl lg:text-5xl font-bold text-gray-800">
          Experienced ReactJS Developers
        </h2>
        <p className="sm:text-base md:text-lg lg:text-xl text-gray-600 font-semibold mt-4 max-w-6xl mx-auto">
          Our ReactJS developers specialize in creating and implementing dynamic
          user interfaces for web and mobile applications using the React
          open-source library. We build seamless, highly functional apps that
          cater to your business needs.
        </p>
      </div>

      <div className=" p">
        <div className="flex flex-col md:flex-row items-center justify-between">
          <div className="w-full md:w-1/3 p-4">
            <img
              src="\assets\images\headerSection\hireReactDev\img2.png"
              alt="Laptop with graph"
              className="h-auto sm:w-3/4 md:w-2/3 lg:w-full object-contain"
            />
          </div>

          <div className="md:w-1/2 lg:w-3/4 p-4 grid grid-cols-1 md:grid-cols-2 gap-6">
            <div className="flex items-start space-x-4">
              <img
                src="\assets\icons\techIcons\icon6.png"
                alt="icon"
                className="w-10 h-10"
              />
              <div>
                <p className="text-lg">
                  Ensure seamless, bug-free deployment with pre-launch testing
                  and issue resolution.
                </p>
              </div>
            </div>

            <div className="flex items-start space-x-4">
              <img
                src="\assets\icons\techIcons\icon7.png"
                alt="icon"
                className="w-10 h-10"
              />
              <div>
                <p className="text-lg">
                  Develop reliable, cross-platform mobile apps that are
                  intuitive and easy to navigate.
                </p>
              </div>
            </div>

            <div className="flex items-start space-x-4">
              <img
                src="\assets\icons\techIcons\icon8.png"
                alt="icon"
                className="w-10 h-10"
              />
              <div>
                <p className="text-lg">
                  Assist with seamless migration and integration of existing web
                  apps and systems.
                </p>
              </div>
            </div>

            <div className="flex items-start space-x-4">
              <img
                src="\assets\icons\techIcons\icon9.png"
                alt="icon"
                className="w-10 h-10"
              />
              <div>
                <p className="text-lg">
                  Design and implement custom plugins to extend the
                  functionality of your web applications.
                </p>
              </div>
            </div>

            <div className="flex items-start space-x-4">
              <img
                src="\assets\icons\techIcons\icon10.png"
                alt="icon"
                className="w-10 h-10"
              />
              <div>
                <p className="text-lg">
                  Create attractive, user-friendly designs that enhance user
                  engagement and experience.
                </p>
              </div>
            </div>

            <div className="flex items-start space-x-4">
              <img
                src="\assets\icons\techIcons\icon11.png"
                alt="icon"
                className="w-10 h-10"
              />
              <div>
                <p className="text-lg">
                  Provide continuous support and maintenance for your ReactJS
                  solutions, ensuring smooth operation at all times.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <AyanshtechAdvantage />

      <div className="max-w-3xl mx-auto p-4 mt-6 w-full ">
        <h2 className="sm:text-3xl md:text-4xl lg:text-5xl font-bold text-center mb-8">
          FAQs
        </h2>
        {reactDevFaqs.map((faq, index) => (
          <div key={index} className="border-b-2 border-blue-300">
            <button
              onClick={() => toggleFAQ(index)}
              className={`w-full text-left py-4 flex justify-between items-center focus:outline-none ${
                activeIndex === index
                  ? "bg-blue-600 text-white px-5 rounded-2xl"
                  : ""
              }`}
            >
              <span className="text-lg">{faq.question}</span>
              <span className="text-2xl">
                {activeIndex === index ? "-" : "+"}
              </span>
            </button>
            {activeIndex === index && (
              <div className="p-4 text-gray-700">{faq.answer}</div>
            )}
          </div>
        ))}
      </div>

      <div id="contact-section">
        {" "}
        <Contact />
      </div>

      <GetInTouch />
    </div>
  </>);
};

export default ReactDeveloper;
